import * as Actions from '../actions';
import { rangeFromDays } from '../actions/studentActivity.actions';

const initialState = {
	trainings: [],
	selectedTrainingId: null,
	range: rangeFromDays(14),
	summary: null,
	summaryLoading: false,
	detail: null,
	detailLoading: false,
	snapshots: [],
	snapshotPolicy: null,
	snapshotsLoading: false,
	error: null
};

const studentActivityReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_STUDENT_ACTIVITY_TRAININGS: {
			return { ...state, trainings: action.payload, error: null };
		}
		case Actions.SET_STUDENT_ACTIVITY_SELECTED_TRAINING: {
			return { ...state, selectedTrainingId: action.payload };
		}
		case Actions.SET_STUDENT_ACTIVITY_RANGE: {
			return { ...state, range: action.payload };
		}
		case Actions.SET_STUDENT_ACTIVITY_SUMMARY: {
			return { ...state, summary: action.payload, summaryLoading: false, error: null };
		}
		case Actions.SET_STUDENT_ACTIVITY_SUMMARY_LOADING: {
			return { ...state, summaryLoading: action.payload };
		}
		case Actions.SET_STUDENT_ACTIVITY_DETAIL: {
			return { ...state, detail: action.payload, detailLoading: false, error: null };
		}
		case Actions.SET_STUDENT_ACTIVITY_DETAIL_LOADING: {
			return { ...state, detailLoading: action.payload };
		}
		case Actions.SET_STUDENT_ACTIVITY_SNAPSHOTS: {
			return {
				...state,
				snapshots: action.payload.snapshots || [],
				snapshotPolicy: action.payload.policy || null,
				snapshotsLoading: false
			};
		}
		case Actions.SET_STUDENT_ACTIVITY_SNAPSHOTS_LOADING: {
			return { ...state, snapshotsLoading: action.payload };
		}
		case Actions.SET_STUDENT_ACTIVITY_ERROR: {
			return { ...state, error: action.payload };
		}
		case Actions.CLEAR_STUDENT_ACTIVITY_DETAIL: {
			return { ...state, detail: null, snapshots: [], detailLoading: false, snapshotsLoading: false };
		}
		default: {
			return state;
		}
	}
};

export default studentActivityReducer;
